import React, { useEffect, useState } from "react";
import { Remarkable } from "remarkable";
import ReactPaginate from "react-paginate";
import CaseStudies from "components/blog/CaseStudies";
import { formatDate } from "@/lib/formatDate";
import Script from "next/script";
import { Link as Scroll } from "react-scroll";
import Link from "next/link";
import Image from "next/image";
import { loadScripts } from "@/lib/loadNewsletterScripts";


function getFeaturedBlogs(blogs) {
  const sorted = [...blogs].sort((a, b) => new Date(b.date) - new Date(a.date));

  const byTag = {
    featured1: [],
    featured2: [],
    featured3: []
  };

  sorted.forEach((blog) => {
    if (!blog.tags) return;
    blog.tags.forEach((tag) => {
      if (tag === "featured1") byTag.featured1.push(blog);
      if (tag === "featured2") byTag.featured2.push(blog);
      if (tag === "featured3") byTag.featured3.push(blog);
    });
  });

  function pickFirstUnique(candidates, existing) {
    return candidates.find((b) => !existing.includes(b));
  }

  const result = [];

  const first = pickFirstUnique(byTag.featured1, result);
  if (first) result.push(first);

  const second =
    pickFirstUnique(byTag.featured2, result) ||
    pickFirstUnique(byTag.featured1.slice(1), result);
  if (second) result.push(second);

  const third =
    pickFirstUnique(byTag.featured3, result) ||
    pickFirstUnique(byTag.featured2.slice(1), result) ||
    pickFirstUnique(byTag.featured1.slice(2), result);
  if (third) result.push(third);

  return result;
}

export function Blogslist({ blogs }) {


  const blogsortByDateCreated = blogs.sort((a, b) => {
    return new Date(b.date) - new Date(a.date);
  });

  const blogFiltered = blogsortByDateCreated.filter((data) => {
    return data;
  });

  const [item, setItem] = useState(blogFiltered);

  const categories = blogFiltered.map((Val) => Val.categories);
  const tags = blogFiltered.map((Val) => Val.tags);

  const categoriesItems = [...new Set(categories.flat(1))];

  const [categoriesState, setCategoriesstate] = useState(categoriesItems);

  const filterCategory = (curcat) => {
    const newItem = blogFiltered.filter((blog) => {
      if (blog.categories) {
        setItem(blogs);
        return blog.categories.some((flag) => flag === curcat);
      }
      return false;
    });
    setItem(newItem);
  };

  const [authorsPick, setAuthorsPick] = useState();

  const filterAuthor = (curcat) => {
    const newItem = blogFiltered.filter((blog) => {
      if (blog.authors) {
        setItem(blogs);
        return blog.authors.some((flag) => flag === curcat);
      }
      return false;
    });
    setItem(newItem);
    setAuthorsPick(curcat);
    setCategoriesstate([]);
  };

  const featuredSorted = getFeaturedBlogs(blogs)

  const [event, setEvent] = useState(blogFiltered);

  const eventBlog = event.filter((blog) => {
    if (blog.tags) {
      return blog.tags?.includes("event");
    }
    return false;
  });

  const [tool, setTool] = useState(blogFiltered);

  const toolBlog = tool.filter((blog) => {
    if (blog.tags) {
      return blog.tags?.includes("useful");
    }
    return false;
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(6);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = item.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = ({ selected }) => {
    setCurrentPage(selected + 1);
    const element = document.getElementById('blogPosts');
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 100,
      });
    }
  };

  useEffect(() => {
    /*
     * It's not possible to have two newsletter forms
     * on a single page using a standard way, so we have
     * to make one of the forms behave as a mirror
     *
     */
    const nameInputElBlog = document.getElementById("_FIRSTNAME");
    const nameInputEl = document.getElementById("FIRSTNAME");
    const handleNameChange = (e) => {
      const value = e.target.value;
      nameInputEl.value = value;
    };

    nameInputElBlog.addEventListener("change", handleNameChange);

    const emailInputElBlog = document.getElementById("_EMAIL");
    const emailInputEl = document.getElementById("EMAIL");
    const handleEmailChange = (e) => {
      const value = e.target.value;
      emailInputEl.value = value;
    };

    emailInputElBlog.addEventListener("change", handleEmailChange);

    return () => {
      nameInputElBlog.removeEventListener("change", handleNameChange);
      emailInputElBlog.removeEventListener("change", handleEmailChange);
    };
  }, []);

  const scrollUp = () => {
    const element = document.getElementById('blogPosts');
    if (element) {
      window.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth'
      });
    }
  };

  function Authors({ post }) {
    return (
      <div className="relative mt-8 flex flex-col sm:flex-row sm:items-center gap-x-2 text-start ">
        <div className="flex -space-x-4">
          {post.avatarUrl.map((avatar) => (
            <Image
              width={32}
              height={32}
              key={avatar}
              src={avatar}
              alt="Author Image"
              className="h-10 w-10 rounded-full bg-gray-100 object-center object-cover bypass-filter"
            />
          ))}
        </div>
        <div className="flex flex-row items-center gap-2 w-full">
          <div className="flex xl:hidden text-sm leading-6">
            {post.authors.length > 2 ? (
              <div className="flex flex-col sm:flex-row gap-1 pt-3 sm:pt-0 sm:pl-4" >
                {post.authors.slice(0, 2).map((author, index) => (
                  <p className="font-semibold text-maingray" key={author}>
                    <Scroll spy to="blogPosts" offset={-100}>
                      <button
                        className=""
                        onClick={() => {
                          filterAuthor(author), setCurrentPage(1);
                        }}
                      >
                        {author}
                      </button>{index !== post.authors.slice(0, 2).length - 1 ? ', ' : '...'}
                    </Scroll>
                  </p>
                ))}
              </div>
            ) : (
              <div className="flex flex-col sm:flex-row gap-1 pt-3 sm:pt-0 sm:pl-2" >
                {post.authors.map((author, index) => (
                  <p className="font-semibold text-maingray flex flex-nowrap" key={author}>
                    <Scroll spy to="blogPosts" offset={-100}>
                      <button
                        className=""
                        onClick={() => {
                          filterAuthor(author), setCurrentPage(1);
                        }}
                      >
                        {author}
                      </button>
                      {index !== post.authors.length - 1 && (
                        <>,&nbsp;</>
                      )}
                    </Scroll>
                  </p>
                ))}
              </div>
            )}
          </div>
          <div className="text-sm leading-6 hidden xl:flex">
            <div className="flex gap-1 pl-4" >
              {post.authors.map((author, index) => (
                <p className="font-semibold text-maingray" key={author}>
                  <Scroll spy to="blogPosts" offset={-100}>
                    <button
                      className=""
                      onClick={() => {
                        filterAuthor(author), setCurrentPage(1);
                      }}
                    >
                      {author}
                    </button>{index !== post.authors.length - 1 ? ', ' : ''}
                  </Scroll>
                </p>
              ))}
            </div>
          </div>

        </div>
      </div>
    )
  }

  function Info({ post }) {
    return (
      <div className="flex items-center gap-x-4 mt-6 border-gray-300 rounded-lg border-1 flex-wrap">
        <h3 className="text-orange-400 font-semibold md:font-bold uppercase">
          {post?.categories[0]}
        </h3>
        <time
          dateTime={post?.created}
          className="text-secgray text-xs"
        >
          {new Date(post?.created).toLocaleDateString(
            "en-US",
            { year: "numeric", month: "long", day: "numeric" }
          )}
        </time>
        <span className="text-xs rounded-lg bg-white shadow-sm px-3 py-1.5 font-medium text-gray-500">
          {post?.readingTime
            ? post.readingTime + " min read"
            : "0 min read"}
        </span>
      </div>
    )
  }

  return (
    <div className="max-w-8xl min-w-full w-full">
      <div className="flex flex-col items-center">
        <div className="relative w-screen max-w-screen flex flex-col items-center pb-16 bg-gradient-to-b from-transparent to-gray-100 border-b border-gray-300">
          <div className="flex justify-center flex-wrap gap-4 max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-8xl items-center w-full  px-8">
            <section className="flex justify-center w-full items-center max-w-5xl shadow-xl bg-gray-50 mt-12 px-8 py-6 rounded-lg mb-16">
              <link
                rel="stylesheet"
                href="https://sibforms.com/forms/end-form/build/sib-styles.css"
              />
              <div
                className="text-center text-white pb-4 grid grid-cols-1 sm:grid-cols-2 items-center  justify-center"
                tabIndex={0}
              >
                <div className="">
                  <p className="small-title !text-secondary text-start pl-0.5">
                    NEWSLETTER
                  </p>
                  <div className="medium-title !text-2xl text-start mt-2">
                    Want product news and updates?
                  </div>
                  <p className="body-text text-lg text-justify mt-2 pl-0.5 mx-auto ">
                    Sign up for The Datopianist.
                  </p>
                </div>
                <div className="sib-form flex !p-0 !font-['Inter'] !max-w-none !w-full sm:!mt-9">
                  <div id="_sib-form-container" className="w-full">
                    <form
                      id="_sib-form"
                      data-type="subscription"
                      className="flex flex-col sm:items-baseline lg:items-start items-center  mx-auto gap-x-4 gap-y-2 w-full "
                    >
                      <div className="lg:flex-row gap-2 flex flex-col w-full pt-4 sm:pt-0">
                        <div className="sib-input sib-form-block !p-0 min-w-[8rem] ">
                          <div className="form__entry entry_block">
                            <div className="entry__field w-full">
                              <input
                                className="input !px-4 !text-black w-full placeholder:!text-gray-400 placeholder:!text-sm  placeholder:!text-sm "
                                maxLength={200}
                                type="text"
                                id="_FIRSTNAME"
                                name="FIRSTNAME"
                                placeholder="Your name"
                                autoComplete="off"
                                data-required="true"
                                title="first name"
                                required
                              />
                            </div>
                            <label className="entry__error entry__error--primary !max-w-full !text-sm text-left bg-[#ffeded] border-[#ff4949] rounded-md"></label>
                          </div>
                        </div>
                        <div className="sib-input sib-form-block !p-0 w-full ">
                          <div className="form__entry entry_block">
                            <div className="entry__field w-full">
                              <input
                                className="input !text-black !px-4 w-full placeholder:!text-gray-400 placeholder:!text-sm "
                                type="text"
                                id="_EMAIL"
                                name="EMAIL"
                                placeholder="Your email address"
                                autoComplete="off"
                                data-required="true"
                                title="email"
                                required
                              />
                            </div>
                            <label className="entry__error entry__error--primary !max-w-full !text-sm text-left bg-[#ffeded] border-[#ff4949] rounded-md"></label>
                          </div>
                        </div>
                      </div>
                      <p className="text-secgray text-start font-['Inter'] text-xs -mt-1 ml-1">
                        We care about your data. Read our{" "}
                        <Link className="text-orange-400" href="/privacy">
                          privacy policy
                        </Link>
                        .
                      </p>
                      <button
                        className="sib-form-block__button sib-form-block__button-with-loader relative w-full sm:w-fit sm:!m-0 btn-primary mt-4"
                        type="button"
                        onClick={async (e) => {
                          e.preventDefault();
                          await new Promise((r) => setTimeout(r, 1000));

                          const nameInputElBlog =
                            document.getElementById("_FIRSTNAME");
                          const nameInputEl =
                            document.getElementById("FIRSTNAME");

                          const nameInputValue = nameInputElBlog.value;

                          const nameErrorElBlog =
                            nameInputElBlog.parentNode.parentNode.getElementsByClassName(
                              "entry__error"
                            )[0];
                          const nameErrorEl =
                            nameInputEl.parentNode.parentNode.getElementsByClassName(
                              "entry__error"
                            )[0];

                          nameErrorElBlog.style = nameErrorEl.style;
                          nameErrorElBlog.innerHTML = nameErrorEl.innerHTML;

                          const emailInputElBlog =
                            document.getElementById("_EMAIL");
                          const emailInputEl = document.getElementById("EMAIL");

                          const emailInputValue = nameInputElBlog.value;

                          const emailErrorElBlog =
                            emailInputElBlog.parentNode.parentNode.getElementsByClassName(
                              "entry__error"
                            )[0];
                          const emailErrorEl =
                            emailInputEl.parentNode.parentNode.getElementsByClassName(
                              "entry__error"
                            )[0];

                          emailErrorElBlog.style = emailErrorEl.style;
                          emailErrorElBlog.innerHTML = emailErrorEl.innerHTML;

                          const form = document
                            .getElementById("sib-form")
                            .getElementsByTagName("button")[0]
                            .click();
                        }}
                      >
                        <svg
                          className="icon clickable__icon progress-indicator__icon sib-hide-loader-icon absolute left-1/3 !m-0 h-6"
                          viewBox="0 0 512 512"
                        >
                          <path d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z" />
                        </svg>
                        Subscribe
                      </button>
                      <input
                        type="text"
                        name="email_address_check"
                        defaultValue=""
                        className="hidden"
                        aria-hidden={true}
                      />
                      <input type="hidden" name="locale" defaultValue="en" />
                    </form>
                    <div
                      id="_error-message"
                      className="sib-form-message-panel !w-fit !m-0 !mt-4 text-base text-left text-[#661d1d] bg-[#ffeded] border border-[#ff4949] rounded"
                    >
                      <div className="sib-form-message-panel__text sib-form-message-panel__text--center">
                        <svg
                          viewBox="0 0 512 512"
                          className="sib-icon sib-notification__icon"
                        >
                          <path d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z" />
                        </svg>
                        <span className="sib-form-message-panel__inner-text">
                          Your subscription could not be saved. Please try
                          again.
                        </span>
                      </div>
                    </div>
                    <div
                      id="_success-message"
                      className="sib-form-message-panel !w-fit !m-0 !mt-4 text-base text-left text-[#085229] bg-[#e7faf0] border border-[#13ce66] rounded"
                    >
                      <div className="sib-form-message-panel__text sib-form-message-panel__text--center">
                        <svg
                          viewBox="0 0 512 512"
                          className="sib-icon sib-notification__icon"
                        >
                          <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z" />
                        </svg>
                        <span className="sib-form-message-panel__inner-text">
                          Your subscription has been successful!
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="medium-title text-left" tabIndex={0}>
              Featured Articles
            </div>
          </div>
          <div className="group grid grid-rows-8 grid-cols-1 lg:grid-rows-1 lg:grid-cols-12 w-full pt-6 pb-8 lg:max-h-[679px] overflow-hidden lg:flex-row max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-8xl items-center text-center px-8  ">
            <div className=" row-start-1 row-end-auto col-span-full lg:row-span-full lg:col-start-1 lg:col-end-10 w-full overflow-hidden rounded-lg ">
              <Link
                href={featuredSorted[0].urlPath}
                className=""
                aria-labelledby="img1"
              >
                <Image
                  width={1000}
                  height={569}
                  src={featuredSorted[0].image}
                  alt="Featured"
                  id="img1"
                  className="object-cover w-full h-full !aspect-[16/9] shadow-xl rounded-lg border ease-in duration-500 group-hover:scale-105 transform"
                />
              </Link>
            </div>
            <div
              tabIndex={0}
              className="group px-4 row-start-4 row-span-4 col-span-full lg:row-span-full lg:col-start-6 lg:col-span-12 p-4 lg:p-8 lg:w-full lg:mt-[14.4%] bg-white shadow-xl rounded-lg z-40"
            >
              <div className="flex items-center gap-x-4 mb-3 border-gray-300 rounded-lg border-1">
                <h3 className="text-orange-400 font-semibold md:font-bold uppercase">
                  {featuredSorted[0]?.categories[0]}
                </h3>
                <time
                  dateTime={featuredSorted[0]?.created}
                  className="text-secgray text-xs"
                >
                  {new Date(featuredSorted[0]?.created).toLocaleDateString(
                    "en-US",
                    { year: "numeric", month: "long", day: "numeric" }
                  )}
                </time>
                <span className="text-xs rounded-lg bg-gray-50 shadow-sm px-3 py-1.5 font-medium text-gray-500">
                  {featuredSorted[0]?.readingTime
                    ? featuredSorted[0].readingTime + " min read"
                    : "0 min read"}
                </span>
              </div>
              <Link href={featuredSorted[0].urlPath} aria-labelledby="img2">
                <h3
                  id="img2"
                  className="medium-title  group-hover:text-orange-400 transition ease-in-out text-start break-words"
                >
                  {featuredSorted[0]?.title}
                </h3>
              </Link>
              <div className="mt-4">
                <p className="pt-2 text-justify text-secgray font-regular line-clamp-3">
                  {featuredSorted[0]?.description}
                </p>
              </div>

              <Authors post={featuredSorted[0]} />


              <Link href={`../${featuredSorted[0]?.urlPath}`}>
                <div className="no-underline btn-primary my-8 lg:mb-0">
                  Read article
                </div>
              </Link>
            </div>
          </div>
          <div className="max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-8xl items-center text-center px-8 ">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-2 min-w-full  ">
              {featuredSorted.slice(1, 3).map((blog, key) => (
                <article
                  key={blog.urlPath}
                  className="mt-8 min-w-full shrink-0 group"
                  tabIndex={0}
                >
                  <div className="grid grid-cols-1 text-start ">
                    <Link
                      href={blog.urlPath}
                      className="overflow-hidden h-full rounded-lg"
                    >
                      <Image
                        width={640}
                        height={360}
                        src={blog.image}
                        className="h-full !aspect-[16/9] rounded-lg object-cover w-full shadow-xl ease-in duration-500 group-hover:scale-105 transform"
                        alt="Blog Post Image"
                      />
                    </Link>
                    <Info post={blog} />
                    <div className="min-w-full w-full">
                      <Link
                        className="mt-2 h-[4.1rem] min-h-[4.1rem] line-clamp-2 text-[#2A3342] text-2xl font-bold w-full min-w-full group-hover:text-orange-400 transition ease-in-out"
                        href={blog.urlPath}
                      >
                        {blog.title}
                      </Link>
                    </div>
                    <div className="pt-2 text-justify text-secgray font-regular line-clamp-3">
                      {blog.description}
                    </div>
                  </div>
                  <Authors post={blog} />
                </article>
              ))}
            </div>
          </div>
        </div>
        <div>
          <div
            id="blogPosts"
            className="max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-8xl px-8"
          >
            <div className="flex flex-col items-start gap-4 pb-8 w-full mt-16 ">
              <button
                className="medium-title text-left hover:text-orange-400"
                onClick={() => {
                  setItem(blogFiltered),
                    setCurrentPage(1),
                    setAuthorsPick(),
                    setCategoriesstate(categoriesItems);
                }}
              >
                All Blog Posts
              </button>
              {authorsPick && (
                <div className="flex gap-4 items-center font-semibold text-maingray justify-center pl-2">
                  from {authorsPick}
                  <Image
                    width={32}
                    height={32}
                    src={`/assets/images/team/${authorsPick}.jpg`
                      .replaceAll(" ", "-")
                      .normalize("NFD")
                      .replace(/[\u0300-\u036f]/g, "")}
                    alt="Author"
                    className="h-10 w-10 rounded-full bg-gray-100 object-center object-cover"
                  />
                </div>
              )}
            </div>
            <div className="blog-categories">
              {categoriesState &&
                categoriesState.map((Val, id) => {
                  return (
                    <button
                      className="active-filter"
                      onClick={() => {
                        setCurrentPage(1), filterCategory(Val);
                      }}
                      key={id}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                        />
                      </svg>
                      {Val}
                    </button>
                  );
                })}
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-2 min-w-full mt-8 ">
              {currentPosts.map((blog, key) => (
                <article
                  key={blog.urlPath}
                  className="mt-8 min-w-full shrink-0 group"
                  tabIndex={0}
                >
                  <div className="grid grid-cols-1 text-start ">
                    <Link
                      href={blog.urlPath}
                      className="overflow-hidden  h-full rounded-lg"
                      title="Blog post image"
                    >
                      <Image
                        width={640}
                        height={360}
                        src={blog.image}
                        className="!aspect-[16/9] h-full rounded-lg object-cover w-full shadow-xl ease-in duration-500 group-hover:scale-105 transform"
                        alt="Blog Post Image"
                      />
                    </Link>
                    <Info post={blog} />
                    <div className="min-w-full w-full">
                      <Link
                        className="mt-2 h-[4.1rem] min-h-[4.1rem] line-clamp-2 text-[#2A3342] text-2xl font-bold w-full min-w-full group-hover:text-orange-400 transition ease-in-out"
                        href={blog.urlPath}
                      >
                        {blog.title}
                      </Link>
                    </div>
                    <div className="pt-2 text-justify text-secgray font-regular line-clamp-3">
                      {blog.description}
                    </div>
                  </div>
                  <Authors post={blog} />
                </article>
              ))}
              <div className="flex justify-center col-span-full">

                <ReactPaginate
                  onPageChange={paginate}
                  pageCount={Math.ceil(item.length / postsPerPage)}
                  previousLabel={"Prev"}
                  nextLabel={"Next"}
                  containerClassName={"pagination"}
                  pageLinkClassName={"page-number"}
                  previousLinkClassName={"page-number"}
                  nextLinkClassName={"page-number"}
                  activeLinkClassName={"active-page"}
                />
              </div>

            </div>
          </div>
        </div>
        <div
          className="flex flex-col justify-start gap-4 w-full xl:mt-24 mt-16 border-t border-gray-300 col-span-full max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-8xl px-8"
          tabIndex={0}
        >
          <div className="medium-title text-left pt-14 hover:text-orange-400">
            Featured Event
          </div>
          <div className="event group">
            <div className="col-span-full row-span-full row-end-auto lg:col-start-1 lg:col-end-10 w-full h-full overflow-hidden lg:rounded-lg lg:border max-h-[22rem]">
              <Link href={eventBlog[0].urlPath}>
                <Image
                  width={1000}
                  height={569}
                  src={eventBlog[0].image}
                  alt="eventBlog"
                  className="!aspect-[16/9] object-cover w-auto h-full row-span-full col-auto shadow-lg ease-in duration-500 group-hover:scale-105 transform"
                />
              </Link>
            </div>
            <div className="event-info group z-40">
              <div className="flex items-center gap-x-4 mb-3 border-1">
                <h3 className="text-orange-400 font-semibold md:font-bold uppercase">
                  {eventBlog[0].categories[0]}
                </h3>
                <span className="text-xs rounded-lg bg-gray-50 px-3 py-1.5 font-medium text-gray-500">
                  {eventBlog[0]?.readingTime
                    ? eventBlog[0].readingTime + " min read"
                    : "0 min read"}
                </span>
              </div>
              <Link href={eventBlog[0].urlPath}>
                <h3 className="medium-title group-hover:text-orange-400 transition ease-in-out text-start">
                  {eventBlog[0].title}
                </h3>
              </Link>
              <div className="mt-4">
                <div className="pt-2 text-justify text-secgray font-regular line-clamp-3">
                  {eventBlog[0].description}
                </div>
                <p className="text-secgray caret-transparent cursor-default text-sm md:text-lg descp ">
                  {eventBlog[0].brief}
                </p>
              </div>
            </div>
          </div>
          <div className="flex justify-center bg-transparent mt-16">
            <Link href="https://ckan.org/events">
              <button className="btn-primary">
                See more events at ckan.org
              </button>
            </Link>
          </div>
        </div>
        <div
          className="relative w-screen max-w-screen border-b border-gray-300 bg-gradient-to-b from-transparent to-gray-100 flex justify-center"
          tabIndex={0}
        >
          <div className="flex flex-col justify-start gap-4 w-full xl:mt-24 mt-16 border-t border-gray-300 col-span-full max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-8xl px-8 bg-transparent">
            <div className="medium-title text-left pt-14 hover:text-orange-400">
              Useful Tools
            </div>
            <div className="event group">
              <div className="col-span-full row-span-full row-end-auto lg:col-start-1 lg:col-end-10 w-full h-full overflow-hidden lg:rounded-lg lg:border max-h-[22rem]">
                <Link href={toolBlog[0].urlPath}>
                  <Image
                    width={1000}
                    height={569}
                    src={toolBlog[0].image}
                    alt="eventBlog"
                    className="!aspect-[16/9] object-cover w-auto h-full row-span-full col-auto shadow-lg ease-in duration-500 group-hover:scale-105 transform"
                  />
                </Link>
              </div>
              <div className="event-info group z-40">
                <div className="flex items-center gap-x-4 mb-3 shadow-lgrounded-lg border-1">
                  <h3 className="text-orange-400 font-semibold md:font-bold uppercase">
                    {toolBlog[0].categories[0]}
                  </h3>
                  <span className="text-xs rounded-lg bg-gray-50 px-3 py-1.5 font-medium text-gray-500">
                    {toolBlog[0]?.readingTime
                      ? toolBlog[0].readingTime + " min read"
                      : "0 min read"}
                  </span>
                </div>
                <Link href={toolBlog[0].urlPath}>
                  <h3 className="medium-title group-hover:text-orange-400 transition ease-in-out text-start">
                    {toolBlog[0].title}
                  </h3>
                </Link>
                <div className="mt-4">
                  <div className="pt-2 text-justify text-secgray font-regular line-clamp-3">
                    {toolBlog[0].description}
                  </div>
                  <p className="text-secgray caret-transparent cursor-default text-sm md:text-lg descp ">
                    {toolBlog[0].brief}
                  </p>
                </div>
              </div>
            </div>
            <div className="flex justify-center bg-transparent my-16">
              <Link href="/blog/useful-tools">
                <button className="btn-primary">See more tools</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}

export default function Blogs({ blogs, casestudies }) {
  return (
    <div>
      <section
        className="flex flex-col items-center justify-center 
    mt-24 md:px-8"
      >
        <div className="flex flex-col gap-5 max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-8xl items-center font-['Inter'] text-center ">
          <h1 className="main-top-title">Blog</h1>
          <p className="font-medium text-xl text-[#556987]"></p>
        </div>
        <div className="font-['Inter']">
          <Blogslist blogs={blogs} />
        </div>
        <div className="flex flex-col max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-8xl">
          <CaseStudies casestudies={casestudies} />
        </div>
      </section>
    </div>
  );
}
